module.exports = __webpack_public_path__ + "static/img/ico_big data@2x.2ba655d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talents/ico_big data@2x.png
// module id = 841V
// module chunks = 0